export default __webpack_public_path__ + "static/media/network-graph-2-lqMAX.d90e1ee9.jpg";